import { Label, Textarea } from '@/components/ui/Input';

const NOMINATIVE_PLACEHOLDERS = [
  '{firstname}',
  '{X}',
  '{jour_ouvre01}',
  '{jour_ouvre02}',
  '{phrase_prospect_1}',
  '{phrase_prospect_2}',
];

const FALLBACK_PLACEHOLDERS = ['{jour_ouvre01}', '{jour_ouvre02}'];

interface Props {
  id: string;
  label: string;
  value: string;
  onChange: (v: string) => void;
  mode?: 'nominative' | 'fallback';
  required?: boolean;
}

export function EmailTemplateEditor({ id, label, value, onChange, mode = 'nominative', required }: Props) {
  const placeholders = mode === 'nominative' ? NOMINATIVE_PLACEHOLDERS : FALLBACK_PLACEHOLDERS;

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <Label htmlFor={id}>
          {label}
          {required && <span className="text-red-500 ml-0.5">*</span>}
        </Label>
        <div className="flex flex-wrap gap-1 justify-end">
          {placeholders.map((p) => (
            <code
              key={p}
              className="text-xs bg-gray-100 text-gray-600 px-1.5 py-0.5 rounded font-mono cursor-pointer hover:bg-brand-primary/10 hover:text-brand-primary transition-colors"
              title="Cliquer pour insérer"
              onClick={() => {
                const el = document.getElementById(id) as HTMLTextAreaElement | null;
                if (!el) return;
                const start = el.selectionStart;
                const end = el.selectionEnd;
                const next = value.slice(0, start) + p + value.slice(end);
                onChange(next);
                requestAnimationFrame(() => {
                  el.focus();
                  const pos = start + p.length;
                  el.setSelectionRange(pos, pos);
                });
              }}
            >
              {p}
            </code>
          ))}
        </div>
      </div>
      <Textarea
        id={id}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        rows={6}
        className="font-mono text-sm"
        placeholder={`Corps de l'email — utilisez les variables ci-dessus`}
        data-testid={`template-${id}`}
      />
    </div>
  );
}
